import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../../utils/helpers';
import './index.css';

const SlashedPrice = ({ courseDetail }) => {
  const currentPrice = useMemo(() => {
    return courseDetail?.attributes?.amount
      ? +courseDetail?.attributes?.amount / 100
      : 0;
  }, [courseDetail?.attributes?.amount]);

  const originalPrice = useMemo(() => {
    return currentPrice + (courseDetail?.attributes?.discount || 0);
  }, [currentPrice, courseDetail?.attributes?.discount]);

  return (
    <div>
      {courseDetail?.attributes?.amount > 0 && (
        <div className="d-flex align-items-center flex-wrap justify-content-center mb-3 justify-content-sm-start">
          {Boolean(courseDetail?.attributes?.discount) && (
            <p className="jen-health-price-cut">
              {formatCurrency(
                originalPrice,
                courseDetail?.attributes?.currency,
                2,
              )}
            </p>
          )}
          <p className="jen-health-price">
            {formatCurrency(
              currentPrice,
              courseDetail?.attributes?.currency,
              2,
            )}
          </p>
          {courseDetail?.attributes?.discount > 0 ? (
            <div className="jen-health-para-div">
              <p className="jen-health-para">For a limited time</p>
            </div>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};

SlashedPrice.propTypes = {
  courseDetail: PropTypes.object,
};

export default SlashedPrice;
